import { Api } from '@monorepo/shared/apiClient';
import { copyToClipboard } from '@monorepo/shared/utils/copyToClipboard';
import { MutationConfig, useMutation } from 'react-query';

type useCopySqlForSigmaDataModelParams = {
  config?: MutationConfig<Api.FetchSqlForDataModelResponse, Api.ErrorResponse>;
};

export const useCopySqlForSigmaDataModel = (
  params?: useCopySqlForSigmaDataModelParams,
) =>
  useMutation(Api.fetchSqlForDataModel, {
    ...params?.config,
    onSuccess: async (sqlForSigma, mutationFuncParams) => {
      await copyToClipboard(sqlForSigma);
      return params?.config?.onSuccess?.(sqlForSigma, mutationFuncParams);
    },
  });
